import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetSettingConfig } from "../../../utilities/api/setting-config";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
    message: string;
}
const initialState = {
    setting: {
        id: "",
        sessionEndDateLimit: "",
        rewardPointsPercent: "",
        minApplicableRewardPoints: "",
        minRewardPointsToClaim: "",
        allocateRewardPoints: true,
        dashboardDefaultInterval: "",
        cancellationPolicy: "",
        reschedulePolicy: "",
        refundPolicy: "",
        contactProcess: "",
    },
    errorMessage: {} as ErrorMessageType,
}

export const GetSettings = createAsyncThunk("Settings/GetSettings", () => GetSettingConfig())

const SettingSlice = createSlice({
    name: "Settings",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(GetSettings.fulfilled, (state, action: PayloadAction<any>) => {
                state.setting = action.payload.data
                localStorage.setItem("dashboard-default-date", action.payload.data.dashboardDefaultInterval)
            })
            .addCase(GetSettings.rejected, (state, action) => {
                state.errorMessage = { message: messages.error.internal_server_error };
            });
    }
})

export default SettingSlice.reducer
